module.exports = __webpack_public_path__ + "static/media/delivery-success.e570899d.svg";